import { generateBlob } from '/utilities/generateBlob';

import * as dynamics from "dynamics.js";

(() => {
    const blobContainers = document.querySelectorAll(
        '[data-animated-blob], [data-blob]'
    );

    Array.from(blobContainers).forEach((blobContainer) => {
        const update = () => {
            const {
                size,
                growth,
                edges,
            } = blobContainer.dataset;

            const { path: blob } = generateBlob({
                size: Number.parseInt(size),
                growth: Number.parseInt(growth),
                edges: Number.parseInt(edges),
            });

            const path = `M${size},0 L${size},${size} L0,${size} L0,0 L${size},0 Z ${blob}`;

            if (blobContainer.getAttribute('d')) {
                dynamics.animate(blobContainer, { d: path }, {
                    type: dynamics.spring,
                    frequency: 200,
                    friction: 200,
                    duration: 1400,
                });
            } else {
                blobContainer.setAttribute('d', path);
            }

            const interval =  Math.floor(Math.random() * (4000 - 2000 + 1) + 2000);

            setTimeout(update, interval);
        };

        update();
    });
})();

(() => {
    const projectTeasers = document.querySelectorAll('[data-project-teaser]');

    Array.from(projectTeasers).forEach((teaser) => {
        const content = teaser.querySelector('[data-project-teaser-content]');
        const description = teaser.querySelector(
            '[data-project-teaser-description]'
        );

        const hover = () => {
            content.style.transform = 'translateY(0)';
        };

        const blur = () => {
            const marginTop = Number.parseInt(
                getComputedStyle(description).marginTop,
                10
            );
            const height = Number.parseInt(
                getComputedStyle(description).height,
                10
            );

            content.style.transform = `translateY(${marginTop + height}px)`;
        };

        teaser.addEventListener('focus', hover);
        teaser.addEventListener('mouseenter', hover);
        teaser.addEventListener('blur', blur);
        teaser.addEventListener('mouseleave', blur);

        blur();
    });
})();
